import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { getCookie } from "../../slidebar/components/DarkMode";
import * as actions from "../redux/PromotionAction";

export const PromotionCopyModal = ({
  showPromo,
  setShowPromo,
  handleOpenDetail,
  handleCopyPromo,
  setSwalProps,
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [mode, setMode] = useState(getCookie("selectedTheme"));
  const [username, setUsername] = useState("");

  const promotionState = useSelector(
    ({ promotion }) => promotion,
    shallowEqual
  );

  const handleClose = () => {
    setShowPromo(undefined);
  };

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  const fetchCashSharePromoList = () => {
    dispatch(
      actions.fetchCashSharePromoList({
        selusername: username,
      })
    ).then((resp) => {
      resp = resp.data;

      if (parseInt(resp.code) !== ApiStatusTypeEnum.SUCCESS) {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  const columnClass = "p-3";

  return (
    <>
      <Modal
        show={!!showPromo}
        onHide={handleClose}
        centered
        size="xl"
        data-bs-theme={mode}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {intl.formatMessage({
              id: "sharePromotionList",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center gap-2 mb-4">
            <input
              type="text"
              className="form-control flex-fill"
              placeholder={intl.formatMessage({ id: "username" })}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchCashSharePromoList();
                }
              }}
            />
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => fetchCashSharePromoList()}
            >
              {intl.formatMessage({ id: "search" })}
            </button>
          </div>
          <div
            className="rounded table-responsive"
            style={{ background: "var(--table-background)" }}
          >
            <table className="w-100">
              <thead>
                <tr className="border-bottom">
                  <th className={columnClass}>
                    {intl.formatMessage({ id: "no" })}
                  </th>
                  <th className={columnClass}>
                    {intl.formatMessage({ id: "title" })}
                  </th>
                  <th className={columnClass}>
                    {intl.formatMessage({ id: "type" })}
                  </th>
                  <th className={columnClass}>
                    {intl.formatMessage({ id: "status" })}
                  </th>
                  <th className={columnClass}>
                    {intl.formatMessage({ id: "free" })}
                  </th>
                  <th className={columnClass}>
                    {intl.formatMessage({ id: "turnover" })}
                  </th>
                  <th className={columnClass}>
                    {intl.formatMessage({ id: "action" })}
                  </th>
                </tr>
              </thead>
              <tbody>
                {promotionState.cashSharePromoList ? (
                  promotionState.cashSharePromoList.cshSharePromotionLists
                    .length > 0 ? (
                    promotionState.cashSharePromoList.cshSharePromotionLists.map(
                      (promotion, index) => (
                        <tr
                          key={promotion.promotionid}
                          className="border-bottom"
                        >
                          <td className={columnClass}>{index + 1}</td>
                          <td className={columnClass}>
                            <div className="fw-semibold mb-1">
                              {promotion.promotiontitle}
                            </div>
                            <div>{promotion.promotiontypedscp}</div>
                          </td>
                          <td className={columnClass}>
                            {promotion.promotiontype}
                          </td>
                          <td className={columnClass}>{promotion.status}</td>
                          <td className={columnClass}>{promotion.free}</td>
                          <td className={columnClass}>{promotion.turnover}</td>
                          <td className={columnClass}>
                            <div className="d-flex">
                              <button
                                className="btn btn-info me-1"
                                onClick={() => {
                                  handleOpenDetail(promotion.promotionid);
                                }}
                                title={intl.formatMessage({
                                  id: "editPromotion",
                                })}
                              >
                                <i className="bi bi-pencil"></i>
                              </button>
                              <button
                                className="btn btn-primary me-1"
                                onClick={() =>
                                  handleCopyPromo(promotion.promotionid)
                                }
                                title={intl.formatMessage({
                                  id: "copyPromotion",
                                })}
                              >
                                <i className="bi bi-copy"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      )
                    )
                  ) : (
                    <tr>
                      <td colSpan={7} className={`text-center ${columnClass}`}>
                        {intl.formatMessage({ id: "noRecordFound" })}
                      </td>
                    </tr>
                  )
                ) : (
                  <tr>
                    <td colSpan={7} className={`text-center ${columnClass}`}>
                      {intl.formatMessage({ id: "noRecordFound" })}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
